import CurrencyInput, { type CurrencyInputProps } from 'react-currency-input-field';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { DepositType, TransferType } from '@fintronners/internal-core/src/transfer/schema';
import { ErrorMessage } from '@/components/common/Forms/feedback/ErrorMessage';

type TransferCurrencyInputProps = CurrencyInputProps;

export const TransferCurrencyInput = ({ ...props }: TransferCurrencyInputProps) => {
  const { control } = useFormContext();
  const [depositType, transferType] = useWatch({ control, name: ['depositType', 'transferType'] });

  return (
    <Controller
      control={control}
      name="amount"
      render={({ field: { value, onChange, disabled }, fieldState: { error } }) => (
        <>
          <CurrencyInput
            className="w-full text-[60px] text-primary outline-none disabled:text-grey25 read-only:text-grey25 read-only:cursor-not-allowed bg-transparent"
            prefix="$"
            value={value || ''}
            decimalsLimit={2}
            intlConfig={{ locale: 'en-US' }}
            onValueChange={(_value) => onChange(_value ?? '')}
            allowNegativeValue={false}
            readOnly={
              disabled &&
              depositType === DepositType.ONE_TIME &&
              transferType === TransferType.DEPOSIT
            }
            placeholder="$0"
            {...props}
          />
          {error && <ErrorMessage hasIcon>{String(error.message)}</ErrorMessage>}
        </>
      )}
    />
  );
};
